import React, { useState, useEffect, useRef } from 'react'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup} from "../../store/popupSlice"
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    }
  ]
}
export default function HomeBanner  ()  {
  const dispatch=useDispatch();
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    const loadVideo = () => setVideoSrc('/assets/home/herovideo2.mp4?v=2');

    if (typeof window === "undefined") return undefined;

    let loaded = false;
    const loadOnce = () => {
      if (loaded) return;
      loaded = true;
      loadVideo();
    };

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    events.forEach((eventName) => {
      window.addEventListener(eventName, loadOnce, { once: true, passive: true });
    });

    const timerId = window.setTimeout(loadOnce, 15000);

    return () => {
      window.clearTimeout(timerId);
      events.forEach((eventName) => {
        window.removeEventListener(eventName, loadOnce);
      });
    };
  }, []);

  useEffect(() => {
    if (videoSrc && videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => {}); // silence autoplay policy errors
    }
  }, [videoSrc]);

  return (
    <>
      <Helmet>
        <link rel="preload" fetchpriority="high" href="/assets/home/blackPoster.webp" as="image" type="image/webp" />
      </Helmet>

      <section className="banner-section header-gap">
        <div className="homebanner-detail">
        <video ref={videoRef} src={videoSrc || undefined} className="img-responsive" autoPlay loop muted playsInline poster="/assets/home/blackPoster.webp" preload="none"/>
          <div>
            <h1 className="heading">Flexible AI-Powered Solutions for Smooth Mobility</h1>
            <p>
              Shaping the Future of <span>AI-Driven Innovation</span> in the Digital Era
            </p>
            <p>21 Days Free Trial | No Credit Card Required</p>
            <Link 
             onClick={() => dispatch(openPopup())}
             className="default-btn animated-btn">
              Book free demo
            </Link>

            <Breadcrumb breadcrumbData={breadcrumbData}/>
          </div>
          <label className="scroll-down-video">
            <FontAwesomeIcon icon={faChevronDown} />
          </label>
        </div>
      </section>
    </>
  );
};
